import * as React from 'react'
import { createIcon } from './createIcon'
import { IconOptions } from './icon-options'

function IconContent({ color }: IconOptions) {
  return (
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9 5V7H15.59L4 18.59L5.41 20L17 8.41V15H19V5H9Z'
      fill={color}
    />
  )
}

export const ShareIcon = createIcon(IconContent)
